/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Duplicatefoldername4Inputs */

const en_coinvestments_dataroom_duplicatefoldername4 = /** @type {(inputs: Coinvestments_Dataroom_Duplicatefoldername4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A folder with this name already exists`)
};

/**
* | output |
* | --- |
* | "A folder with this name already exists" |
*
* @param {Coinvestments_Dataroom_Duplicatefoldername4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_duplicatefoldername4 = /** @type {((inputs?: Coinvestments_Dataroom_Duplicatefoldername4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Duplicatefoldername4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_duplicatefoldername4(inputs)
});
export { coinvestments_dataroom_duplicatefoldername4 as "coInvestments_dataRoom_duplicateFolderName" }